export const maxNameLength = 50;
export const maxDescLength = 300;

export const fieldNames = {
  name: 'name',
  files: 'files',
  description: 'description',
  availableToClient: 'availableToClient',
  fromDate: 'fromDate',
  toDate: 'toDate'
};
